import { Link } from "react-router-dom";

import { Button } from "@/atoms";
import { buildAdminCompanyDetailRouteHandler, strings } from "@/constants";
import { ButtonSizeEnum, ButtonVariantEnum } from "@/enums";
import type { CompanyType } from "@/types";

export const CompanyRow = ({ company }: { company: CompanyType }) => (
    <li
        className="
            flex
            flex-col
            gap-3
            px-4
            py-4
            transition-colors
            hover:bg-gray-50
            sm:flex-row
            sm:items-center
            sm:justify-between
            sm:px-6
        "
    >
        <div className="min-w-0 flex-1">
            <div
                className="
                    flex
                    flex-wrap
                    items-center
                    gap-2
                "
            >
                <p
                    className="
                        truncate
                        text-sm
                        font-semibold
                        text-text-primary
                    "
                >
                    {company.name}
                </p>
                <span
                    className={`
                        shrink-0
                        rounded-full
                        px-2
                        py-0.5
                        text-xs
                        font-semibold
                        tracking-wide
                        uppercase
                        ${company.isEnabled ? "bg-primary/10 text-primary" : "bg-error/10 text-error"}
                    `}
                >
                    {company.isEnabled ? strings.admin.statusEnabled : strings.admin.statusDisabled}
                </span>
            </div>
            <p
                className="
                    mt-1
                    truncate
                    text-xs
                    text-text-secondary
                "
            >
                {company.email}
            </p>
        </div>
        <Link
            className="self-start sm:self-auto"
            to={buildAdminCompanyDetailRouteHandler(company.id)}
        >
            <Button
                size={ButtonSizeEnum.SM}
                variant={ButtonVariantEnum.PRIMARY}
            >
                {strings.admin.viewCompany}
            </Button>
        </Link>
    </li>
);
